import _slicedToArray from "/Users/lucky.zhang/workspaces/workspace_go/src/routerman/web/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _createForOfIteratorHelper from "/Users/lucky.zhang/workspaces/workspace_go/src/routerman/web/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _toConsumableArray from "/Users/lucky.zhang/workspaces/workspace_go/src/routerman/web/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "/Users/lucky.zhang/workspaces/workspace_go/src/routerman/web/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/Users/lucky.zhang/workspaces/workspace_go/src/routerman/web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.string.ends-with.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.number.constructor.js";
import { store } from '@/store/index';
import { compare } from '@/utils/stringFun';
var getNodeVal = function getNodeVal(lines, names, vals) {
  if (lines.length == 0 || names.length == 0) {
    return;
  }
  var name = names[0];
  lines.forEach(function (line) {
    if (line.label == name) {
      vals.push(line.value);
      if (names.length > 1 && line.children && line.children.length > 0) {
        names = names.slice(1);
        getNodeVal(line.children, names, vals);
      }
    }
  });
};

// const getType = (type, isPrimaryDomain) => {
//     // if(type == 'AAAA' || type == 'TXT' || type == 'SRV' || type == 'MX'){
//     //     type = 'A'
//     // }
//     if(type == 'NS'){
//         if (type == '' || !isPrimaryDomain) {
//             type = 'NS'
//         }
//     }else if(type == 'CNAME'){
//         type = 'CNAME'
//     }else{
//         type = 'A'
//     }
//     return type
// }

var isDNSType = function isDNSType(type) {
  return type == 'A' || type == 'AAAA' || type == 'CNAME' || type == 'TXT' || type == 'SRV' || type == 'MX' || type == 'NS' || type == 'CAA' || type == 'SPF' || type == 'NAPTR' || type == 'PTR';
};
export var toTreeNode = function toTreeNode(node, nodeMap) {
  var id = node.value;
  if (nodeMap.has(id)) {
    var childrenList = nodeMap.get(id);
    node['children'] = childrenList;
    childrenList.forEach(function (val) {
      toTreeNode(val, nodeMap);
    });
  } else {
    node['leaf'] = true;
  }
};
export var getNode = function getNode(lines, lineNames) {
  var nodes = [];
  lineNames.forEach(function (path) {
    var vals = [];
    var namePaths = path.split('/');
    getNodeVal(lines, namePaths, vals);
    nodes.push(vals);
  });
  return nodes;
};
var subSuffix = function subSuffix(domain) {
  if (domain && domain.endsWith('.') && domain != '.') {
    domain = domain.substring(0, domain.length - 1);
  }
  return domain;
};
var changeRegionToTarget = function changeRegionToTarget(region) {
  var targets = [];
  var targetStatusMap = new Map();
  if (region.hc.targetsStatus) {
    region.hc.targetsStatus.forEach(function (targetStatus) {
      targetStatusMap.set(targetStatus.target, targetStatus.status);
    });
  }
  var _loop = function _loop(key) {
    // 例如：ARRB 去掉B变成 ARR
    if (isDNSType(key.toUpperCase().replace('B', ''))) {
      region[key].forEach(function (tar) {
        var target = {};
        target.value = tar.target;
        target.ttl = tar.ttl;
        target.weight = tar.weight === undefined ? 1 : tar.weight;
        target.type = key.toUpperCase().replace('B', '');
        // if(target.type == 'MX'){
        //     let _targets = tar.target.trim().split(/\s+/);
        //     // target.extend = _targets[0]
        //     target.value =  _targets[0] + ' ' + subSuffix(_targets[1])
        // }else 
        if (target.type == 'CNAME' || target.type == 'NS' || target.type == 'PTR') {
          target.value = subSuffix(tar.target);
        }
        target.priority = key.toUpperCase().indexOf('B') > -1 ? 1 : 0;
        if (region.hc.tplId == 0) {
          // 设置默认值
          target.status = 0;
          // A、AAAA记录才进行健康检查
          if (target.type == 'A' || target.type == 'AAAA') {
            target.isHc = true;
          } else {
            target.isHc = false;
          }
        } else if (targetStatusMap.has(target.value)) {
          target.status = targetStatusMap.get(target.value);
          target.isHc = true;
        }
        targets.push(target);
      });
    }
  };
  for (var key in region) {
    _loop(key);
  }
  return targets;
};
var getTargetKey = function getTargetKey(targets, hc) {
  var keys = [];
  targets.forEach(function (target) {
    keys.push(target.type + '#' + target.value + '#' + target.ttl
    // + '#' + target.extend 
    + '#' + target.weight + '#' + target.status + '#' + target.priority + '#' + target.isHc);
  });
  keys.push("tpl:" + hc.tplId);
  keys.sort();
  return keys.join(',');
};
var getLinePath = function getLinePath(viewMap, names) {
  var lines = [];
  names.forEach(function (name) {
    lines.push(viewMap.get(name));
  });
  return lines;
};
var getLabel = function getLabel(labelMap, names) {
  var lines = [];
  names.forEach(function (name) {
    // if(!labelMap.get(name)){
    //     return true
    // }
    lines.push(labelMap.get(name).join('/'));
  });
  return lines;
};
export var setSelectedNames = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(addNames, removeNames) {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return store.dispatch('viewinfo/setSelectedNames', {
            addNames: addNames,
            removeNames: removeNames
          });
        case 2:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function setSelectedNames(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
export var viewToRegion = function viewToRegion(view, zone) {
  var lang = store.getters["language/language"];
  var tplMap = getTplMap();
  var defRow = {};
  defRow.names = ['default'];
  defRow.labels = lang == 'en' ? ['Default'] : ['默认'];
  defRow.lines = [['default']];
  defRow.targets = changeRegionToTarget(view.default);
  defRow.hc = getHc(view.default, tplMap);
  var smartRows = [];
  if (view.region) {
    var smartMap = new Map();
    view.region.forEach(function (reg) {
      var targets = changeRegionToTarget(reg);
      var key = getTargetKey(targets, reg.hc);
      if (smartMap.has(key)) {
        smartMap.get(key).names.push(reg.name);
      } else {
        var smartObj = {};
        smartObj.targets = targets;
        smartObj.names = [reg.name];
        smartObj.labels = [];
        smartObj.hc = getHc(reg, tplMap);
        smartMap.set(key, smartObj);
      }
    });
    var lineMap = store.getters["viewinfo/getLineMap"].get(zone);
    var viewMap = lineMap.get('viewinfoMap');
    var labelMap = lineMap.get('lineLabelMap');
    var nameArr = [];
    smartMap.forEach(function (val) {
      nameArr = nameArr.concat(val.names);
      val.lines = getLinePath(viewMap, val.names);
      val.labels = getLabel(labelMap, val.names);
      smartRows.push(val);
    });
    setSelectedNames(nameArr, []);
  }
  console.log(defRow);
  console.log(smartRows);
  return {
    default: defRow,
    region: smartRows
  };
};
export var deepCopy = function deepCopy(data) {
  return JSON.parse(JSON.stringify(data));
};
export var getUUID = function getUUID() {
  return Number(Math.random().toString().substr(2, 36) + Date.now()).toString(36);
};
var transRegionToRecord = function transRegionToRecord(region) {
  var records = [];
  region.names.forEach(function (name, idx) {
    region.targets.forEach(function (target) {
      var record = deepCopy(target);
      record.id = getUUID();
      record.name = name;
      record.label = region.labels[idx];
      record.lines = region.lines[idx];
      record.hc = deepCopy(region.hc);
      if (record.hc.tplId == 0) {
        record.isHc = false;
      }
      record.isEdit = false;
      record.hcSettingVisible = false;
      records.push(record);
    });
  });
  return records;
};
export var viewMapToDomainRegion = function viewMapToDomainRegion(viewMap, zone) {
  var domainRegion = new Map();
  var _loop2 = function _loop2() {
    var records = [];
    var regionObj = viewToRegion(viewMap[domain], zone);
    if (regionObj.default) {
      var defReg = regionObj.default;
      var defRecords = transRegionToRecord(defReg);
      records.push.apply(records, _toConsumableArray(defRecords));
    }
    var regionRecords = [];
    if (regionObj.region && regionObj.region.length > 0) {
      regionObj.region.forEach(function (val) {
        var regRecords = transRegionToRecord(val);
        regionRecords.push.apply(regionRecords, _toConsumableArray(regRecords));
      });
    }
    // 排序
    regionRecords.sort(compare('label', 0));
    records.push.apply(records, regionRecords);

    // domainRegion[domain] = records
    domainRegion.set(domain, records);
  };
  for (var domain in viewMap) {
    _loop2();
  }
  console.log(domainRegion);
  return domainRegion;
};
var getHc = function getHc(region, tplMap) {
  var tplId = 0;
  var tplName = '';
  if (region.hc && region.hc.tplId != 0) {
    var tpl = tplMap.get(region.hc.tplId);
    if (tpl) {
      tplId = tpl.ID;
      tplName = tpl.tplName;
    }
  }
  return {
    tplName: tplName,
    tplId: tplId,
    hcStatus: region.hc.hcStatus
  };
};
var strMapToObj = function strMapToObj(strMap) {
  var obj = Object.create(null);
  var _iterator = _createForOfIteratorHelper(strMap),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value = _slicedToArray(_step.value, 2),
        k = _step$value[0],
        v = _step$value[1];
      obj[k] = v;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return obj;
};
var getTargets = function getTargets(targets, hc) {
  var defMap = new Map();
  if (targets && targets.length > 0) {
    targets.forEach(function (target) {
      var type = target.type.toLowerCase();
      var obj = {
        'ttl': target.ttl,
        // 'target': (type == 'mx' && target['extend']) ? (target['extend'] + ' ' + target.value) : target.value
        'target': target.value
      };
      if (type == 'a') {
        obj['weight'] = target['weight'] === '' ? 1 : target['weight'];
      }
      obj['priority'] = !target['priority'] || hc.tplId == 0 ? 0 : target['priority'];
      var key = type + (obj['priority'] == 1 ? 'b' : '');
      if (defMap.has(key)) {
        defMap.get(key).push(obj);
      } else {
        defMap.set(key, [obj]);
      }
    });
  }
  return defMap;
};
export var regionToView = function regionToView(record) {
  var formData = {};
  var defView = getTargets(record.default.targets, record.default.hc);
  // defView.set('type', getTargetType(record.default.targets, isPrimaryDomain))
  defView.set('hc', orgHc(record.default));
  formData['default'] = strMapToObj(defView);
  if (record.region.length > 0) {
    var regions = [];
    record.region.forEach(function (val) {
      // let type = getTargetType(val.targets, isPrimaryDomain)
      val.names.forEach(function (name) {
        var region = getTargets(val.targets, val.hc);
        region.set('name', name);
        // region.set('type', type)
        region.set('hc', orgHc(val));
        regions.push(strMapToObj(region));
      });
    });
    formData['region'] = regions;
  }
  console.log(formData);
  return formData;
};
export var mergeRegions = function mergeRegions(records) {
  var recordMap = new Map();
  records === null || records === void 0 ? void 0 : records.forEach(function (record) {
    if (recordMap.has(record.name)) {
      var region = recordMap.get(record.name);
      region.targets.push(record);
      if (record.isHc && record.hc.tplId != 0) {
        region.hc = record.hc;
      }
    } else {
      var _region = {};
      _region.targets = [record];
      _region.names = [record.name];
      _region.hc = record.hc;
      recordMap.set(record.name, _region);
    }
  });
  var recordObj = {
    default: {},
    region: []
  };
  recordMap.forEach(function (region, key) {
    if (key == 'default') {
      recordObj.default = region;
    } else {
      recordObj.region.push(region);
    }
  });
  console.log(recordObj);
  return recordObj;
};

// const getTargetType = (targets, isPrimaryDomain) => {
//     let type = '';
//     for(let target of targets){
//         if(!target['priority'] || target['priority'] == 0){
//             type = getType(target.type.toUpperCase(), isPrimaryDomain)
//             if (type == 'A'){
//                 break
//             }
//         }
//     }
//     return type
// }

var orgHc = function orgHc(region) {
  var hc = region.hc;
  if (region.targets && region.targets.length > 0) {
    var hcTargets = [];
    region.targets.forEach(function (target) {
      // A、AAAA记录才进行健康检查
      if (target.isHc && (target.type == 'A' || target.type == 'AAAA')) {
        hcTargets.push({
          'target': target.value
        });
      }
    });
    if (hc && hc.tplId != 0) {
      hc.targetsStatus = hcTargets;
    }
  }
  return hc;
};
var disableNode = function disableNode(node, needDisabledNames) {
  if (node.children && node.children.length > 0) {
    node.children.forEach(function (item) {
      disableNode(item, needDisabledNames);
    });
  } else {
    if (needDisabledNames.indexOf(node.value) != -1) {
      node['disabled'] = 'disabled';
    } else {
      node['disabled'] = '';
    }
  }
};
export var getView = function getView(values, zone) {
  var lineMap = store.getters["viewinfo/getLineMap"];
  var viewInfo = JSON.parse(lineMap.get(zone).get('lines'));
  var selectedNames = store.getters["viewinfo/getSelectedNames"];
  var needDisabledNames = ['default'];
  if (selectedNames.length > 0) {
    selectedNames.forEach(function (name) {
      if (values.indexOf(name) == -1) {
        needDisabledNames.push(name);
      }
    });
  }
  if (needDisabledNames.length > 0) {
    viewInfo.forEach(function (item) {
      disableNode(item, needDisabledNames);
    });
  }
  return viewInfo;
};
export var getAllView = function getAllView(zone) {
  var lineMap = store.getters["viewinfo/getLineMap"];
  var viewInfo = JSON.parse(lineMap.get(zone).get('lines'));
  return viewInfo;
};
export var getTplMap = function getTplMap() {
  var tplMap = store.getters["viewinfo/getTplMap"];
  return tplMap;
};
export var transRRs2Regions = function transRRs2Regions(rrs) {
  var regionMap = new Map();
  rrs.forEach(function (rr) {
    if (regionMap.has(rr.name)) {
      var region = regionMap.get(rr.name);
      var targetObj = {};
      targetObj.hc = {
        hcStatus: 0,
        tplId: 0,
        tplName: ''
      };
      targetObj.isHc = false;
      targetObj.label = '默认';
      targetObj.name = 'default';
      targetObj.priority = 0;
      targetObj.status = 0;
      targetObj.ttl = rr.ttl;
      targetObj.type = rr.type;
      targetObj.value = dealVal(rr.content, rr.type);
      targetObj.weight = 1;
      region.default.targets.push(targetObj);
    } else {
      var _targetObj = {};
      _targetObj.hc = {
        hcStatus: 0,
        tplId: 0,
        tplName: ''
      };
      _targetObj.isHc = false;
      _targetObj.label = '默认';
      _targetObj.name = 'default';
      _targetObj.priority = 0;
      _targetObj.status = 0;
      _targetObj.ttl = rr.ttl;
      _targetObj.type = rr.type;
      _targetObj.value = dealVal(rr.content, rr.type);
      _targetObj.weight = 1;
      var targets = [_targetObj];
      var names = ['default'];
      var hc = {
        hcStatus: 0,
        tplId: 0,
        tplName: ''
      };
      var _region2 = {};
      _region2.default = {};
      _region2.default.hc = hc;
      _region2.default.names = names;
      _region2.default.targets = targets;
      _region2.region = [];
      _region2.domain = rr.name;
      regionMap.set(rr.name, _region2);
    }
  });
  console.log(regionMap);
  return regionMap;
};
var dealVal = function dealVal(val, type) {
  if (val.endsWith('.') && (type == 'CNAME' || type == 'NS' || type == 'PTR')) {
    val = val.substring(0, val.length - 1);
  }
  return val;
};